var _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApi = function SvgApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m73.298 16.285-4.112-4.113H56.302l-4.112 4.113v12.883l4.112 4.112h12.884l4.112-4.112V16.285ZM30.15 31.92h-7.38L11.21 43.48v7.38l11.56 11.56h7.38l11.56-11.56v-7.38L30.15 31.92ZM26.231 31.632v-7.224l2.231-2.125H50.88",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.231 61.243v7.224l2.231 2.125H50.88",
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.172,
    cy: 47.261,
    r: 6.284,
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.436,
    cy: 70.592,
    r: 8.558,
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgApi;